'use client';

import { useTranslations } from 'next-intl';
import Lottie from 'lottie-react';

import styles from '@/styles/notfound.module.scss';
import Link from 'next/link';
import nodataAnime from '@/assets/lotties/online_hold.json'

import useStore from '@store/index';
import PreloaderComponent from '../preloader';
import { event } from '@lib/ga';
import Image from 'next/image';

export default function OnlineHoldComponent() {
  const t = useTranslations();

  const { companyDetails, hasHydrated } = useStore();

  if (!hasHydrated) {
    return <PreloaderComponent />;
  }

  return (<>
    <div className={styles.main}>
      <div className={styles.orderCompletePage + ' ' + styles.onlineHoldPage}>
        <div className={styles.mainContent + ' ' + styles.notFoundContent + ' ' + styles.onlineHoldContent}>
          <div className={styles.logoContainer}>
            <Image 
              src="/assets/images/main-logo.png" 
              alt="Farmhouse Pizza Logo"
              width={238}
              height={199}
              className={styles.mainLogo}
            />
          </div>

          <Lottie animationData={nodataAnime} loop={true} className={styles.lottie} />

          <h1>{t('onlinehold.title')}</h1>
          <p>{t('onlinehold.description')}</p>

          {(companyDetails?.phone && companyDetails?.phone !== '') && <div className={styles.driverInfo}>
            <div className={styles.phoneInfo}>
              <div>
                <h4>{t('TrackOrder.phone')}</h4>
                <p>{companyDetails?.phone || t('TrackOrder.noPhoneNumber')}</p>
              </div>
            </div>
            
            <Link href={`tel:${companyDetails?.phone.replace(/ /g, '')}`} className={styles.phoneLink} onClick={() => {
              event({
                action: 'call_restaurant_trackorder',
                category: 'engagement',
                label: 'Call Restaurant from online hold page',
              })
            }} aria-label="Call Restaurant">
              <div className={styles.phoneButton}>
                <Image src="/assets/images/trackorder/phone-icon.svg" width={24} height={24} alt="Phone" />
              </div>
            </Link>
          </div>}

          <Link href="/" className={styles.backButton}>
            <button className={styles.backButton} onClick={() => window.location.reload()}>
              {t('onlinehold.reloadPage')}
            </button>
          </Link>
        </div>
      </div>
    </div>
  </>);
}